export default "__VITE_ASSET__109a7233__"